import { apiFetch } from '@/platform/lib/api';

export type HaulListing = {
  id: string;
  sellerUserId: string;
  name: string;
  description?: string;
  priceCents: number;
  currency: string;
  productKind?: string;
  marketplaceRealm?: string;
  sourceClaimId?: string;
  sourceMaterialLineId?: string;
  sourceMaterialID?: string;
  sourceMaterialCategory?: string;
  listingFormat?: 'fixed_price' | 'auction';
  auctionEndsAt?: string;
  currentBidCents?: number;
  highBidderUserId?: string;
  status: string;
  claimTitle?: string;
  communityValidityRating?: number;
  validityPositiveMass?: number;
  agreeNet?: number;
  imageObjectPaths?: string[];
  imageUrls?: string[];
};


export function listHaulMarketplace(params?: {
  cursor?: string;
  limit?: number;
  format?: string;
  material?: string;
  category?: string;
  search?: string;
}) {
  const q = new URLSearchParams();
  if (params?.cursor) q.set('cursor', params.cursor);
  if (params?.limit) q.set('limit', String(params.limit));
  if (params?.format) q.set('format', params.format);
  if (params?.material) q.set('material', params.material);
  if (params?.category) q.set('category', params.category);
  if (params?.search) q.set('search', params.search);
  const qs = q.toString();
  return apiFetch<{ listings: HaulListing[]; nextCursor?: string }>(
    `/haul-marketplace/listings${qs ? `?${qs}` : ''}`,
  );
}

export function listClaimListings(claimId: string) {
  return apiFetch<{ listings: HaulListing[] }>(`/claims/${claimId}/listings`);
}

export function listFindFromClaim(
  claimId: string,
  lineId: string,
  body: {
    priceCents: number;
    currency?: string;
    listingFormat?: 'fixed_price' | 'auction';
    auctionEndsAt?: string;
    name?: string;
    description?: string;
  },
) {
  return apiFetch<HaulListing>(`/claims/${claimId}/materials/${lineId}/list`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function placeHaulBid(claimId: string, productId: string, amountCents: number) {
  return apiFetch<{ listing: HaulListing; bid: { amountCents: number } }>(
    `/claims/${claimId}/listings/${productId}/bids`,
    { method: 'POST', body: JSON.stringify({ amountCents }) },
  );
}
